import React from 'react';
import { I18n } from 'react-redux-i18n';
import Icon from 'components/Icon';

type KeyIndicatorsProps = {
  dn_total?: number;
  dn_spirits: number;
  dn_bdx: number;
  dn_champ: number;
  dn_italy: number;
  dn_napa: number;
  dn_whisky: number;
  dn_rum: number;
  dn_brandy: number;
  dn_gin: number;
  dn_vodka: number;
  dn_tequila: number;
  avg_all_price?: number | null;
  median_all_price?: number | null;
  median_btg_price?: number | null;
  displayed_currency?: string | null;
};

export const KeyIndicators = ({
  dn_total = 0,
  dn_spirits,
  dn_bdx,
  dn_champ,
  dn_italy,
  dn_napa,
  dn_whisky,
  dn_rum,
  dn_brandy,
  dn_gin,
  dn_vodka,
  dn_tequila,
  avg_all_price,
  median_all_price,
  median_btg_price,
  displayed_currency
}: KeyIndicatorsProps) => {
  return (
    <>
      {/* DN Data Section */}
      <div className="info-section">
        <div className="section-title">
          {I18n.t('storePopup.keyIndicators.distributionNumbers')}
        </div>
        <div className="info-row">
          <div className="label">
            {I18n.t('storePopup.keyIndicators.totalDN')}:
          </div>
          <div className="value">{dn_total}</div>
        </div>
        {dn_spirits > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.spirits')}:
            </div>
            <div className="value">{dn_spirits}</div>
          </div>
        )}
        {dn_bdx > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.bordeaux')}:
            </div>
            <div className="value">{dn_bdx}</div>
          </div>
        )}
        {dn_champ > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.champagne')}:
            </div>
            <div className="value">{dn_champ}</div>
          </div>
        )}
        {dn_italy > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.italy')}:
            </div>
            <div className="value">{dn_italy}</div>
          </div>
        )}
        {dn_napa > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.napa')}:
            </div>
            <div className="value">{dn_napa}</div>
          </div>
        )}
        {dn_whisky > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.whisky')}:
            </div>
            <div className="value">{dn_whisky}</div>
          </div>
        )}
        {dn_rum > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.rum')}:
            </div>
            <div className="value">{dn_rum}</div>
          </div>
        )}
        {dn_brandy > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.brandy')}:
            </div>
            <div className="value">{dn_brandy}</div>
          </div>
        )}
        {dn_gin > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.gin')}:
            </div>
            <div className="value">{dn_gin}</div>
          </div>
        )}
        {dn_vodka > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.vodka')}:
            </div>
            <div className="value">{dn_vodka}</div>
          </div>
        )}
        {dn_tequila > 0 && (
          <div className="info-row">
            <div className="label">
              {I18n.t('storePopup.keyIndicators.tequila')}:
            </div>
            <div className="value">{dn_tequila}</div>
          </div>
        )}
      </div>

      {/* Number of References Section */}
      <div className="info-section">
        <div className="section-title">
          {I18n.t('storePopup.keyIndicators.numberOfReferences')}
        </div>
        <div className="info-row">
          <div className="label">
            {I18n.t('storePopup.keyIndicators.totalReferences')}:
          </div>
          <div className="value">{dn_total}</div>
        </div>
      </div>

      {/* Pricing Section */}
      {(avg_all_price || median_all_price || median_btg_price) && (
        <div className="info-section">
          <div className="section-title">
            {I18n.t('storePopup.keyIndicators.pricing')}
          </div>
          {avg_all_price && (
            <div className="info-row">
              <div className="label">
                {I18n.t('storePopup.keyIndicators.averagePrice')}:
              </div>
              <div className="value">
                {avg_all_price.toLocaleString('fr-FR', {
                  style: 'currency',
                  currency: displayed_currency || 'EUR'
                })}
              </div>
            </div>
          )}
          {median_all_price && (
            <div className="info-row">
              <div className="label">
                {I18n.t('storePopup.keyIndicators.medianPrice')}:
              </div>
              <div className="value">
                {median_all_price.toLocaleString('fr-FR', {
                  style: 'currency',
                  currency: displayed_currency || 'EUR'
                })}
              </div>
            </div>
          )}
          {median_btg_price && (
            <div className="info-row">
              <div className="label">
                {I18n.t('storePopup.keyIndicators.medianBtgPrice')}:
              </div>
              <div className="value">
                {median_btg_price.toLocaleString('fr-FR', {
                  style: 'currency',
                  currency: displayed_currency || 'EUR'
                })}
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
